import { ReactNode, useState } from 'react';

import * as Avatar from '@radix-ui/react-avatar';
import classNames from 'classnames';

import { ImagePlaceholderIcon } from '@anyx/shared-icons';


type AvatarStatus = Parameters<NonNullable<Avatar.AvatarImageProps['onLoadingStatusChange']>>[0];

interface AnyChatImageProps {
  className?: string;
  iconClassName?: string;
  src?: string | null;
  placeholderIconSize?: 'sm' | 'md' | 'lg';
  placeholderIcon?: ReactNode;
}

export const AnyChatImage = ({
  className,
  src,
  placeholderIconSize,
  placeholderIcon,
  iconClassName,
}: AnyChatImageProps) => {
  const [loadingStatus, setLoadingStatus] = useState<AvatarStatus>('idle');

  return (
    <Avatar.Root asChild>
      <div
        className={classNames('anc-image', className, {
          'animate-pulse': loadingStatus === 'loading' && !!src,
        })}
      >
        <Avatar.Image
          src={src || undefined}
          className="h-full w-full object-cover"
          onLoadingStatusChange={setLoadingStatus}
        />
        <Avatar.Fallback delayMs={src ? 1000 : 0} asChild>
          <div className={classNames('anc-image__fallback', iconClassName)}>
            {placeholderIcon ? (
              placeholderIcon
            ) : (
              <ImagePlaceholderIcon
                className={classNames('text-gray-7', {
                  'h-6 w-6': placeholderIconSize === 'sm',
                  'h-8 w-8': placeholderIconSize === 'md',
                  'h-14 w-14': placeholderIconSize === 'lg',
                })}
              />
            )}
          </div>
        </Avatar.Fallback>
      </div>
    </Avatar.Root>
  );
};
